import {Ref, ref, watch} from 'vue'
import axios, {AxiosInstance} from 'axios'
import {environment} from '@/environments/environment'

const client: AxiosInstance = axios.create({
	baseURL: `${environment.API_CLIENT}`,
	withCredentials: true,
})

const cache = new Map<string, string>()

export function useBundleThumbnail(bundleId: string, variantId: string, brandId: string, visible: Ref<boolean>) {
	const url = ref<string | null>(null)
	const loading = ref(true)
	const error = ref(false)

	const key = `${bundleId}/${variantId}/${brandId}`

	function fetch() {
		if (cache.has(key)) {
			url.value = cache.get(key)!
			loading.value = false
		} else {
			loading.value = true
			client.get(
					`/bet-image-renderer/bundle-template-thumbnail/${bundleId}/${variantId}/mobile/${brandId}`,
					{ responseType: 'blob' }
			)
					.then(response => {
						const objectUrl = URL.createObjectURL(response.data)
						cache.set(key, objectUrl)
						url.value = objectUrl
					})
					.catch(() => { error.value = true })
					.finally(() => { loading.value = false })
		}
	}

	watch(visible, (isVisible) => {
		if (isVisible) fetch()
	}, { immediate: true })
	
	return { url, loading, error }
}